import { GridColumnHeader } from '../components/Grid/types';
import { Attribute, DataSource } from '../types/entities.types';

const gridHeaders: GridColumnHeader[] = [
  {
    name: 'businessMetadata.asset_name',
    label: 'Name',
    width: '20%',
    filter: {
      type: 'text',
      remoteSearchFields: ['asset_name'],
    },
    sortable: true,
    remoteSortField: 'asset_name',
  },
  {
    name: 'businessMetadata.asset_id',
    label: 'Asset ID',
    width: '20%',
    filter: {
      type: 'text',
      remoteSearchFields: ['asset_id'],
    },
  },
  {
    name: 'businessMetadata.owner',
    label: 'Owner',
    width: '20%',
    remoteSortField: 'owner',
    filter: {
      type: 'text',
      remoteSearchFields: ['owner'],
    },
  },
  {
    name: 'sourceSpecificMetadata.TableauDashboard.dash_total_score',
    label: 'Dash Total Score',
    width: '10%',
    remoteSortField: 'dash_total_score',
    sortable: true,
  },
  {
    name: 'sourceSpecificMetadata.TableauDashboard.level_of_impact',
    label: 'Level of Impact',
    width: '10%',
    remoteSortField: 'level_of_impact',
    filter: {
      type: 'aggregation',
      aggregationName: 'level_of_impact_aggregation',
      remoteSearchFields: ['level_of_impact'],
      filterSelectProps: {
        isClearable: false,
      },
    },
  },
  { name: 'links', label: 'External URL', width: '10%' },
  { name: 'lineage', label: 'Lineage', width: '10%' },
];

const attributesMap: Attribute[] = [
  {
    name: 'businessMetadata.asset_name',
    label: 'Name',
    showInColumn: 0,
    description: 'Name of the dashboard',
  },
  {
    name: 'businessMetadata.asset_id',
    label: 'Id',
    showInColumn: 0,
    description: 'Id of the dashboard',
  },
  {
    name: 'sourceSpecificMetadata.TableauDashboard.level_of_impact',
    label: 'Level of Impact',
    showInColumn: 1,
    description: 'Level of impact',
    type: 'string',
  },
  {
    name: 'sourceSpecificMetadata.TableauDashboard.dash_total_score',
    label: 'Dash Total Score',
    showInColumn: 1,
    description: 'Dash total score',
    type: 'string',
  },
  {
    name: 'businessMetadata.owner',
    label: 'Owner',
    showInColumn: 2,
    description: 'Owner',
  },
  {
    name: 'technicalMetadata.asset_type',
    label: 'Asset Type',
    showInColumn: 0,
    description: 'Asset type',
  },
  {
    name: 'technicalMetadata.asset_status',
    label: 'Asset Status',
    showInColumn: 0,
    description: 'Asset status',
  },
  {
    name: 'sourceSpecificMetadata.TableauDashboard.datahub_urn',
    label: 'Datahub URN',
    showInColumn: 1,
    description: 'Datahub URN',
  },
  {
    name: 'sourceSpecificMetadata.TableauDashboard.container_hierarchy',
    label: 'Container Hierarchy',
    showInColumn: 1,
    description: 'Container Hierarchy',
    type: 'array',
  },
  {
    name: 'sourceSpecificMetadata.TableauDashboard.external_url',
    label: 'External Url',
    showInColumn: 1,
    description: 'External Url',
    type: 'link',
  },
];

const customQueryForListPage = `
  TableauDashboard {
    dash_total_score
    external_url
    level_of_impact
  }
`;

const customQueryForDetailsPage = `
  TableauDashboard {
    container_hierarchy
    dash_total_score
    datahub_urn
    external_url
    level_of_impact
  }
`;

export const TableauDashboardConfig: DataSource = {
  id: '8',
  name: 'TableauDashboard',
  showColumns: false,
  showPartitionColumns: false,
  showLineage: true,
  showLineageTable: true,
  showLineagePipeline: false,
  showLineageQuery: false,
  showLineageCloned: false,
  showLineageCW: false,
  showLineageColumn: false,
  showLineageDashboard: false,
  gridHeaders,
  attributesMap,
  customQueryForListPage,
  customQueryForDetailsPage,
  glossary: false,
};
